import React from 'react'
import Detail from 'src/shared/components/data-display/Detail/Detail'
import DetailContent from 'src/shared/components/data-display/Detail/kit/DetailContent/DetailContent'
import DetailRow from 'src/shared/components/data-display/Detail/kit/DetailRow/DetailRow'
import DetailText from 'src/shared/components/data-display/Detail/kit/DetailText/DetailText'
import { formatCurrencyToFixed } from 'src/shared/hooks/formatCurrency'
import { useFormatDate } from 'src/shared/hooks/useFormatDate'

export interface DescuentoDetailsProps {
    monto: number
    fecha: Date
    nombre: string
    tipo: 'Estancia' | 'Extras'
}

const DescuentoDetails = ({ monto, fecha, nombre, tipo }: DescuentoDetailsProps) => {
    const { formatCustomDate } = useFormatDate()

    return (
        <Detail>
            <DetailContent>
                <DetailRow>
                    <DetailText>{`Descuento (${tipo})`}</DetailText>
                    <DetailText textAlign='right'>
                        {formatCustomDate(fecha, 'MMM, DD YYYY')}
                    </DetailText>
                </DetailRow>
                <DetailRow>
                    <DetailText type='bold'>{nombre}</DetailText>
                    <DetailText type='bold' textAlign='right'>
                        -{formatCurrencyToFixed(monto)}
                    </DetailText>
                </DetailRow>
            </DetailContent>
        </Detail>
    )
}

export default DescuentoDetails
